import(/* webpackMode: "eager" */ "/app/apps/data-dashboard/styles/documents.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@4.3.4_next@15.5.24_@babel+core@7.29.0_@opentelemetry+api@1.9.0_@types+node@20_32b6ad35a3489715c452b65cc7701bad/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
